export const data = [
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 165,
    "maskH": 158,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_Data-Set-15.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 164,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_Data-Set-6.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_açaí.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_burger.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 162,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_comida-fit.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 160,
    "maskX": 830,
    "maskY": 50,
    "circle": true,
    "file": "fomede_LIBER_cupcake.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 164,
    "maskX": 830,
    "maskY": 49,
    "circle": true,
    "file": "fomede_LIBER_dadinho.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_esfiha.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 159,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_feijoada.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 162,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_frango-frito.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 165,
    "maskH": 156,
    "maskX": 830,
    "maskY": 50,
    "circle": true,
    "file": "fomede_LIBER_hambúrguer.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 155,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_japa.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 165,
    "maskX": 854,
    "maskY": 34,
    "circle": true,
    "file": "fomede_LIBER_lanche.png"
  },
  {
    "circle": true,
    "file": "fomede_LIBER_macarrão.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 163,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_marmita.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 164,
    "maskH": 163,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_panqueca.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 163,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_pastel.png"
  },
  {
    "circle": true,
    "file": "fomede_LIBER_pão.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 163,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_risoto.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_salada.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 160,
    "maskX": 830,
    "maskY": 50,
    "circle": true,
    "file": "fomede_LIBER_salgadinho.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 160,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_sanduba.png"
  },
  {
    "circle": true,
    "file": "fomede_LIBER_sonho.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 163,
    "maskH": 157,
    "maskX": 830,
    "maskY": 51,
    "circle": true,
    "file": "fomede_LIBER_sorvete.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1080,
    "maskW": 165,
    "maskH": 164,
    "maskX": 875,
    "maskY": 36,
    "circle": true,
    "file": "fomede_LIBER_yakisoba.png"
  },
  {
    "mask": 1,
    "width": 1000,
    "height": 1000,
    "maskW": 150,
    "maskH": 150,
    "maskX": 530,
    "maskY": 39,
    "circle": false,
    "file": "março-on-fire-restaurantes-feed.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1920,
    "maskW": 195,
    "maskH": 195,
    "maskX": 582,
    "maskY": 236,
    "circle": false,
    "file": "março-on-fire-restaurantes-story.png"
  },
  {
    "mask": 1,
    "width": 1000,
    "height": 1000,
    "maskW": 263,
    "maskH": 249,
    "maskX": 72,
    "maskY": 311,
    "circle": true,
    "file": "modelo_feed_com_logo.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1920,
    "maskW": 263,
    "maskH": 249,
    "maskX": 652,
    "maskY": 1394,
    "circle": true,
    "file": "modelo_stories_com_logo.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1920,
    "maskW": 226,
    "maskH": 225,
    "maskX": 170,
    "maskY": 1063,
    "circle": true,
    "file": "vemproapp_generica_restaurante_feed.png"
  },
  {
    "mask": 1,
    "width": 1000,
    "height": 1000,
    "maskW": 167,
    "maskH": 167,
    "maskX": 247,
    "maskY": 556,
    "circle": true,
    "file": "vemproapp_generica_restaurante_story.png"
  },
  {
    "mask": 1,
    "width": 1200,
    "height": 1200,
    "maskW": 218,
    "maskH": 218,
    "maskX": 962,
    "maskY": 318,
    "circle": true,
    "file": "vestamosnoaiq_desconto_black-feed.png"
  },
  {
    "mask": 1,
    "width": 1080,
    "height": 1920,
    "maskW": 313,
    "maskH": 313,
    "maskX": 149,
    "maskY": 115,
    "circle": true,
    "file": "vestamosnoaiq_desconto_black-story.png"
  }
]